import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_URL } from '../../../config';
import { toApiError } from '../../../lib/api-error';

type SlugOverrideMode = 'slug' | 'not-slug';

export function useSetSlugOverride(propertyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ parentPath, mode }: { parentPath: string; mode: SlugOverrideMode }) => {
      const res = await fetch(`${API_URL}/properties/${propertyId}/slug-overrides`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ parentPath, mode }),
      });
      if (!res.ok) throw await toApiError(res, 'Failed to set slug override');
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['site-graph', propertyId] });
    },
  });
}

export function useRemoveSlugOverride(propertyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ parentPath }: { parentPath: string }) => {
      const res = await fetch(`${API_URL}/properties/${propertyId}/slug-overrides`, {
        method: 'DELETE',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ parentPath }),
      });
      if (!res.ok) throw await toApiError(res, 'Failed to remove slug override');
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['site-graph', propertyId] });
    },
  });
}
